import Vue from 'vue'

import { BootstrapVue, ToastPlugin, ModalPlugin } from 'bootstrap-vue'

import '@/libs/compositionApi'

import { ApmVuePlugin } from '@elastic/apm-rum-vue'
import VueGtm from '@gtm-support/vue2-gtm'

import AuthPlugin from '@/plugins/auth'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/vue-select'

//  Global Mixins
import helperMixin from './mixins/helpers'

import '@/libs/custom-directives'

// import core styles
require('@core/scss/core.scss')
// import assets styles
require('@/assets/scss/style.scss')

Vue.mixin(helperMixin)

if (process.env.NODE_ENV === 'production') {
  Vue.use(ApmVuePlugin, {
    config: {
      serviceName: 'captain-web',
      serverUrl: process.env.VUE_APP_APM_SERVER_URL,
      environment:
        process.env.VUE_APP_ENV === 'staging' ? 'staging' : 'production',
    },
  })
}

// Boostrap Vue
Vue.use(BootstrapVue)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Auth Plugin
Vue.use(AuthPlugin)
// GTM
Vue.use(VueGtm, {
  id: 'GTM-WMS5MG8',
  enabled: true,
  vueRouter: router,
  trackOnNextTick: false,
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
